import { render, staticRenderFns } from "./ProductViewImport.vue?vue&type=template&id=5a240461&scoped=true&"
import script from "./ProductViewImport.vue?vue&type=script&lang=js&"
export * from "./ProductViewImport.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewImport.vue?vue&type=style&index=0&id=5a240461&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a240461",
  null
  
)

export default component.exports